export default {"src":"/_next/static/media/invalid-name.828bb9ce.svg","height":16,"width":16};